import React from 'react'
import { Icon, l } from '@manychat/manyui'

import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import { subheading } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

const IconString = convertToIconString(Icon.Note, {
  size: 30,
  color: '#CAAB7C',
})

interface CommentNodeEmptyProps {
  placeholderText?: l.MakeTranslateReturnValue
  placeholderTextColor?: string
}
export const CommentNodeEmpty = ({
  placeholderTextColor,
  placeholderText,
}: CommentNodeEmptyProps) => {
  return (
    <view
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <sprite image={IconString} style={{ marginBottom: 8 }} />
      <richtext
        style={{
          ...subheading,
          color: placeholderTextColor,
          textAlign: 'center',
        }}
        text={l.getString(placeholderText)}
      />
    </view>
  )
}
